<template>
  <el-form
    status-icon
    :model="ruleForm"
    :rules="rules"
    label-position="top"
    ref="ruleForm"
    label-width="120px"
    v-loading="loading"
    class="carpo-form demo-ruleForm"
  >
    <el-form-item :label="$t('amount_fuel_quota')" prop="amount">
      <el-input-number
        :disabled="ruleForm.disabled"
        v-model="ruleForm.amount"
        :step="10"
        :min="0"
      ></el-input-number>
    </el-form-item>
    <el-form-item :label="$t('DATE_')" prop="date">
      <date-picker
        :disabled="ruleForm.disabled"
        class="el-input__inner"
        v-model="ruleForm.date"
        view="year"
        format="jYYYY-jMM-jDD"
        :locale="$i18n.locale"
        clearable
      />
    </el-form-item>

    <el-form-item
      :label="$t('SERIALNUMBER')"
      prop="fuel_card.id"
      v-loading="fuelLoading"
    >
      <el-select
        disabled
        :placeholder="$t('SELECT_PLACEHOLDER')"
        :collapse-tags="!ruleForm.disabled"
        clearable
        filterable
        v-model="ruleForm.fuel_card.id"
      >
        <el-option
          v-for="item in fuels"
          :key="item.id"
          :label="item.serial_number"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item
      class="col-span-full"
      :label="$t('description')"
      prop="description"
    >
      <el-input
        :disabled="ruleForm.disabled"
        type="textarea"
        v-model="ruleForm.description"
      ></el-input>
    </el-form-item>

    <FormConfirmation
      v-show="!ruleForm.disabled"
      @resetForm="resetForm('ruleForm')"
      @submitForm="submitForm('ruleForm')"
      :edit="null"
      :loading="submitLoading"
    />
  </el-form>
</template>
<script>
import { resetForm } from '@/mixins/resetForm'
import FormConfirmation from '@/components/elements/formConfirmation.vue'
import { addFuelQuotas, editFuelQuotas, fuels } from '@/api/fuel'
import { jalaliToGregorian } from '@/mixins/jalaliToGregorian'
import { gregorianToJalali } from '@/mixins/gregorianToJalali'
export default {
  mixins: [resetForm, jalaliToGregorian, gregorianToJalali],
  props: {
    quota: {
      type: Object,
      required: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    FormConfirmation,
  },
  data() {
    return {
      submitLoading: false,
      fuelLoading: true,
      fuels: [],
      ruleForm: {
        amount: '',
        disabled: this.$route.name.includes('VIEW') ? true : false,
        description: '',
        id: null,
        date: '',
        fuel_card: {
          id: this.$route.params.id,
        },
      },
      rules: {
        amount: [
          {
            required: true,
            message: this.$i18n.t('REQUIRED_FIELD', {
              type: this.$i18n.t('amount_fuel_quota'),
            }),
            trigger: 'blur',
          },
        ],
        fuel_card: {
          id: [
            {
              required: true,
              message: this.$i18n.t('REQUIRED_CHOOSE', {
                type: this.$i18n.t('SERIALNUMBER'),
              }),
              trigger: 'blur',
            },
          ],
        },
        date: [
          {
            required: true,
            message: this.$i18n.t('REQUIRED_FIELD', {
              type: this.$i18n.t('DATE_'),
            }),
            trigger: 'blur',
          },
        ],
      },
    }
  },
  watch: {
    quota(val) {
      if (val) {
        this.ruleForm = val
        this.ruleForm.date = this.gregorianToJalali(val.date)
        this.ruleForm.disabled = this.$route.name.includes('VIEW')
          ? true
          : false
      }
    },
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const actionPayload = {
            amount: this.ruleForm.amount,
            description: this.ruleForm.description,
            fuel_card: this.ruleForm.fuel_card.id,
            date: this.jalaliToGregorian(this.ruleForm.date, this.$i18n.locale),
          }
          var dispatchFunc = this.quota == null ? addFuelQuotas : editFuelQuotas
          if (this.quota) {
            actionPayload.id = this.quota.id
          }
          this.submitLoading = true
          dispatchFunc.api(actionPayload).then((res) => {
            this.submitLoading = false
            if (res) {
              this.$notify.success({
                title:
                  this.$t('subsidized_capacity') +
                  ' ' +
                  this.$t('SUCCESSFULLY_DONE'),
                duration: 5000,
                customClass: 'succ_msg',
              })
              this.resetForm(formName)

              this.$emit('tableData', {
                ...actionPayload,
                type: this.quota == null ? 'add' : 'edit',
                id: res.id,
              })
            }
          })
        } else {
          this.$notify.error({
            title: this.$i18n.t('FIXED_ERRORS', {
              type: this.$i18n.t(this.$route.name),
            }),
            duration: 5000,
            customClass: 'error_msg',
          })
          return false
        }
      })
    },
  },
  created() {
    fuels.api().then((res) => {
      if (res) {
        this.fuels = res.results
        this.fuelLoading = false
        this.ruleForm.fuel_card.id = +this.$route.params.id
      }
    })
  },
}
</script>
